export const LOGGED_IN_ONLY_PAGES = ['/page/lp','/test-redirect-cms-page','/page/test-redirect-cms-page'];
